import { Stack, StackProps } from '@optimus-web/core';

export const InlinedFormElement = ({ children, ...other }: StackProps) => (
    <Stack spacing="200" alignment="end" itemAlignment="end" {...other}>
        {children}
    </Stack>
);
